import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=1b27d7c1&"
import script from "./ButtonGroup.vue?vue&type=script&lang=js&"
export * from "./ButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ButtonGroup.vue?vue&type=custom&index=0&blockType=stype&lang=less"
if (typeof block0 === 'function') block0(component)

export default component.exports